<template>
    <div class="m-t-20 m-b-20 container">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
        <b-carousel-list
            v-if="slides.length"
            v-model="model" 
            :data="slides"
            :repeat="true"
            :as-indicator="false"
            :arrow-hover="false"
            :items-to-show="5">
            
            <template slot="item" slot-scope="props">
                <div>
                    <div v-if="props.list.clientWebsite">
                        <a target="_blank" @click="redirect(props.list.clientWebsite)" :href="props.list.clientWebsite">
                            <img :src="props.list.image" alt="supplier-image">
                        </a>
                    </div>
                    <div v-else>
                        <img :src="props.list.image" alt="suplier-image">
                    </div>
                </div>
            </template>
            
        </b-carousel-list>
    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
export default {
    props:{
        dataUrl:{
            type:String,
            default:""
        },
        
    },
    data(){
        return{
            slides:[],
            loading:false,
            values:0,
            model:0
        }
    },
    methods:{
        async fetchSuppliers(){
            this.loading = true
            this.slides = await getHandler(this.dataUrl, {error:false, success:false})
            this.loading = false
        },
        redirect(url){
            window.open(url, "_blank")
        }
    },
    created(){
        this.fetchSuppliers()
    }
}
</script>

<style lang="scss" scoped>
 img{
     max-height:60px;
     margin:10px 10px;
 }

.carousel-slides{
    margin:0px auto;
}

</style>